import { CallTagsForSingleCallRemoteDto } from '../../../../generated/signalR/call-tags-for-single-call-remote-dto';
import { LongRunningContextCategoryTyp } from '../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

export class CallTagsUpdatedByServer {
   public static readonly type = '[CallTags] call tags updated by server';

   constructor(public calls: CallTagsForSingleCallRemoteDto[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CALL_TAGS)
export class UpdateCallTag {
   public static readonly type = '[CallTags] update call tag';

   constructor(public callId: number, public tagKey: string, public tagValue: string, public messageId: string = null) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CALL_TAGS)
export class InitiateCallTagHistoryLoad {
   public static readonly type = '[CallTags] initiate call tag history load';

   constructor(public uniqueCallId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CALL_TAGS)
export class LoadCallTagForHistoryCall {
   public static readonly type = '[CallTags] load call tag for history call';

   constructor(public uniqueCallId: string) {}
}

export class SetUniqueCallIdForHistory {
   public static readonly type = '[CallTags] set unique call id for history';

   constructor(public uniqueCallId: string) {}
}

export class LoadSpecificTagForHistoryMessage {
   public static readonly type = '[CallTags] Load Specific Tag For History Message';

   constructor(public messageId: string, public tagName: string) {}
}

export class SetMessageHistoryTag {
   public static readonly type = '[CallTags] Set Message History Tag';

   constructor(public messageId: string, public tagName: string, public tagValue: string) {}
}
